import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Navbar } from '../navbar/navbar';
import { Footer } from '../footer/footer';
import { AuthContextService } from '../shared/auth-context.service';
import { ReferralContextService } from './referral-context.service';

@Component({
  selector: 'app-referral-success',
  standalone: true,
  imports: [CommonModule, Navbar, Footer],
  templateUrl: './referral-success.html',
  styleUrl: './referral.css'
})
export class ReferralSuccess implements OnInit {
  patientName = '';
  reasonText = '';
  stateCode = '';

  constructor(private router: Router, private auth: AuthContextService, private ctx: ReferralContextService) {
    const referral = this.ctx.getFormData();
    const info = this.auth.getPatientInfo() || ({} as any);
    const first = (referral.firstname || info.legalFirstName || '').toString().trim();
    const last = (referral.lastname || info.legalLastName || '').toString().trim();
    this.patientName = [first, last].filter(Boolean).join(' ');
    this.stateCode = (referral.stateOfCare || info.state || '').toString();
    const visit = (referral.visitReason || info.visitType || '').toString();
    if (visit.toLowerCase().includes('psychotherapy')) this.reasonText = 'Psychotherapy';
    else this.reasonText = 'Medication Management';
  }

  private pushDataLayerEvent(eventName: string, payload: Record<string, unknown> = {}): void {
    const normalizedEventName = String(eventName || '').trim();
    if (!normalizedEventName) return;
    try {
      const dataLayer = (window as any).dataLayer = (window as any).dataLayer || [];
      dataLayer.push({
        event: normalizedEventName,
        ...payload
      });
    } catch {}
  }

  ngOnInit(): void {
    this.pushDataLayerEvent('ols_referral_form_submission');
  }

  onExit() { window.location.href = 'https://animosanopsychiatry.com/'; }
  onBook() {
    try {
      const params = new URLSearchParams(window.location.search || '');
      const fromUrl = (params.get('ab_tests') || '').trim();
      const fromSession = (sessionStorage.getItem('ab_tests') || '').trim();
      const raw = fromUrl || fromSession;
      if (raw) {
        window.location.href = `https://ols.myasp.care/scheduler?ab_tests=${encodeURIComponent(raw)}`;
        return;
      }
    } catch {}
    window.location.href = 'https://ols.myasp.care/scheduler';
  }
}


